// Dock section wrapping the existing `AdsActivityCard` so it can be a
// registered entry in `sectionRegistry.tsx` rather than inline JSX in
// `ActivityDockExpandedPanel`. Owns its own refresh state + auth/urgency
// wiring; the panel just passes navigation callbacks down through the
// section render context.

import { useCallback, useState } from "react";
import { AdsActivityCard } from "@/components/ads-assistant/AdsActivityCard";
import { useAuth } from "@/contexts/AuthContext";
import { useWorkspaceUrgencyContext } from "@/contexts/WorkspaceUrgencyContext";
import { canEditAdsGuidance } from "@/lib/adsAssistantPermissions";

export type AdsActivitySectionProps = {
  onOpenAdsIngestion: () => void;
  onOpenAdsLibrary: () => void;
};

export function AdsActivitySection(props: AdsActivitySectionProps) {
  const auth = useAuth();
  const urgency = useWorkspaceUrgencyContext();
  const [refreshing, setRefreshing] = useState(false);
  const canOpenLibrary = canEditAdsGuidance(auth);

  const handleRefresh = useCallback(async () => {
    if (refreshing) return;
    setRefreshing(true);
    try {
      await Promise.resolve(urgency?.refreshAdsActivity?.());
    } finally {
      setRefreshing(false);
    }
  }, [refreshing, urgency]);

  return (
    <AdsActivityCard
      activity={urgency?.adsActivity ?? null}
      refreshing={refreshing}
      onRefresh={() => void handleRefresh()}
      hasManualForm={false}
      canOpenLibrary={canOpenLibrary}
      onOpenLibraryTab={props.onOpenAdsLibrary}
      onOpenIngestionTab={props.onOpenAdsIngestion}
    />
  );
}
